import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { BOItem } from '../../models/BOItem.model';
import { Utilities } from '../../common/utilities';
import { PatientRiskFactorService } from '../../services/patientRiskFactor.service';
import { RiskFactorsTypeService } from '../../services/riskFactorsType.service';

@Component({
  selector: 'app-patient-risk-factor',
  templateUrl: './patient-risk-factor.component.html',
  styleUrls:  ['./patient-risk-factor.component.css' ]
})
//export class PatientRiskFactorComponent implements OnInit, OnChanges {
export class PatientRiskFactorComponent implements OnInit, OnChanges {

    @Input() id!: number;
    @Input() riskFactorType!: string;
    @Input() riskFactorName!: string;
    @Input() riskFactorDetail!: string;
    @Input() posInArray!:number;
    @Input() uniqueId!: string;
    @Output() posSended = new EventEmitter<{ uniqueId: string }>(); // ← Cambia el tipo
    @Output() posSendedId = new EventEmitter<{ itemId: number }>(); // ← Cambia el tipo


  riskFactorsTypeList:BOItem[]=[];
 // riskFactorsTypeList:BOPatientRiskFactor[]=[];


  constructor( private _formBuilder : FormBuilder,
               private _patientRiskFactorService: PatientRiskFactorService,
               private _riskFactorsTypeService      : RiskFactorsTypeService
  )
  { }

  riskFactorFormGroup = this._formBuilder.group({
    posInArray:{ value: null, disabled: true },
    riskFactorName: { value: null, disabled: true },
    riskFactorDetail: { value: null, disabled: true },
  })

  ngOnInit(): void {

    this._riskFactorsTypeService.getAll().subscribe({
      next:(data)=>
      {

        this.riskFactorsTypeList=data;

        this.riskFactorFormGroup.patchValue({
        posInArray: this.posInArray +1,
        riskFactorName: Utilities.getRelativeTypeName(this.riskFactorType, this.riskFactorsTypeList),
        riskFactorDetail:this.riskFactorDetail
       })

      },
      error:(err)=>{
        console.log("Ocurrió un error en la descarga de tipo parientes");
      }
    })
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Evitamos el primer cambio porque ngOnInit ya lo maneja
    if (changes['posInArray'] && !changes['posInArray'].firstChange) {
      this.riskFactorFormGroup.patchValue({
        posInArray: this.posInArray + 1
      });
    }
  }

deleteItem(): void {
  this.posSended.emit({ uniqueId: this.uniqueId }); // ← Emite ID, no posición
}

deleteItemSingle(): void {
  this.posSendedId.emit({ itemId: this.id }); // ← Emite ID, no posición
}

}
